import React from 'react';
import clsx from 'clsx';
import { ReactComponent as CheckIcon } from '../../assets/icons/mini-check.svg';
import styles from './Checkbox.module.scss';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  className?: string;
}

export function Checkbox({ checked, onChange, label, className }: Props) {
  return (
    <label className={clsx(styles.wrapper, className)}>
      <input
        type="checkbox"
        className={styles.input}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={clsx(styles.box, { [styles.boxChecked]: checked })}>
        {checked && <CheckIcon className={styles.check} />}
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}
